import { Injectable, InjectionToken, Inject } from '@angular/core';

export interface IAppSettings {
  sAccount: string;
  omnitureEnabled: boolean;
  reservationActiveStatuses: Array<number>;
  BackToOffice: boolean;
  HotelingCloudClientId: string;
  ConciergeScope: string;
  HotelingCloudApiUrl: string;
  HotelingCloudApiVersion: string;
  EmailSuffix: string;
  AmenityExpirationTime: string;
  DGuestLink: string;
  ReservationAttendeesLimit: number;
  VirtualAttendeesLimit: number;
  InOfficeAttendeesLimit: number;
  BufferAttendeesCount: number;
  MaxNumberLimit: number;
  GlobalSearchLimit: number;
}

export const APP_SETTINGS = new InjectionToken<IAppSettings>('APP_SETTINGS');

export interface IErrorMessages {
  DelegateTokenError: string;
  ValidateReservationAlert: string;
  ReservationConfirmationUnexpectedError: string;
  ValidateWailistError: string;
  CreateReservationError: string;
  GenericError: string;
}

export const ERROR_MESSAGES = new InjectionToken<IAppSettings>('ERROR_MESSAGES');
export const SPACE_FEATURES_ICON = new InjectionToken<any>('SPACE_FEATURES_ICON');
export const SPACE_TYPE_ICON = new InjectionToken<any>('SPACE_TYPE_ICON');

@Injectable({ providedIn: 'root' })
export class UserSettingsService {
  private UserAlias: string = '';

  constructor(
    @Inject(APP_SETTINGS) private AppSettings: IAppSettings,
    @Inject(ERROR_MESSAGES) private ErrorMessages: IErrorMessages,
    @Inject(SPACE_FEATURES_ICON) private SpaceFeaturesIcon: any,
    @Inject(SPACE_TYPE_ICON) private SetupTypeIcon,
  ) {}

  set userAlias(alias: string) {
    this.UserAlias = alias;
  }

  get userAlias(): string {
    return this.UserAlias;
  }

  get appSettings(): IAppSettings {
    return this.AppSettings;
  }

  get errorMessages(): IErrorMessages {
    return this.ErrorMessages;
  }

  get spaceFeaturesIcon() {
    return this.SpaceFeaturesIcon;
  }
  get setupTypeIcon() {
    return this.SetupTypeIcon;
  }
}
